export default {
  ChannelManagement: {
    Header: {
      ps0: '开始测试API... ',
      ps1: ', 当前sku数量: ',
      ps2: '，当前订单数量: ',
      ps3: '，符合抓单条件的订单数量: ',
      api: 'API测试 ',
      method: '渠道',
      shop: '店铺',
      type: '店铺类型',
      Parent: '所属公司',
      status: '渠道仓状态',
      Name: '渠道仓名称',
      Store: '店铺状态',
      Authorization: '授权状态',
      New: '新增网店',
      empower: '授权',

      taxCode: '税号',
      accountCode: '账户编码',
      currency: '币种',
      autoTableStatus: '是否为自动单',
      shippingCostAutoStatus: '订单是否已有快递单',
      project: '项目',
      typeOfFreight: '运费类型',
      one: '默认发货仓库',
      two: '指定发货仓库',
      thr: '发货仓库',
    },
    Main: {
      code: '网店编码',
      name: '网店名称',
      channel: '销售渠道',
      Parent: '所属公司',
      status: '授权状态',
      time: '授权时间',
      expiration: '授权到期时间',
      store: '网店类型',
      Nam: '渠道仓名称',
      statu: '渠道仓状态',
      sta: '店铺状态',
      Creator: '创建人',
      Creation: '创建时间',
      Associated: '关联门店',
      products: '自动下载商品',
      orders: '自动下载订单',
      inventory: '自动同步库存',
      Operate: '操作',
      she: '网店设置',
      shipment: '自动确认发货',
      Day: '天',
      ps: '请输入自动确认发货天数',
      ps1: '请选择自动下载商品',
      ps2: '请输入网店名称',
      ps3: '该店铺已授权',
      ps4: '停用授权',
      ps5: '恢复授权',
      ps6: '渠道仓操作，是否继续?',
      ps7: '是否删除?',
      ps8: '启用状态，不可删除',
      ps9: '保存成功',
      ps91: '操作成功',
      distribution: '分配物流',
      productPrice: '商品价格',
      innerSkuCode: '平台SKU编码',
      oldPrice: '历史单价',
      price: '当前单价',
      newPrice: '未来单价',
      updatePriceTime: '生效时间',
      fileName: '网店商品价格管理',
      errorMsg1: '平台SKU编码不能为空',
      errorMsg2: '当前单价 与 （未来单价和生效时间）至少填写一个',
      errorMsg3: '未来单价和生效时间必须同时存在',
      errorMsg4: '请填写完整的表格数据',
      fileErrorMsg1: 'EXCEL导入的数据缺失，请校验后再导入！',
      fileErrorMsg2: '存在重复数据，请处理后再导入',
      fileErrorMsg3: '在系统中不存在，请检查导入的平台SKU编码是否正确！',
    },
    new: {
      shop: '新增店铺',
      editShop: '编辑店铺',
      title: '基本信息',
      name: '网店名称',
      code: '网店编码',
      Channel: '渠道类型',
      Type: '网店类型',
      charge: '负责人',
      company: '所属公司',
      Invoice: '发票种类',
      Associated: '关联门店',
      describe: '描述',
      relateWarehouse: '关联渠道仓',
      warehouse: '渠道仓',
      Warehousename: '渠道仓名称',
      Store: '店铺配置',
      products: '自动下载商品',
      orders: '自动下载订单',
      inventory: '自动同步库存',
      security: '同步安全值',
      Note: '注：库存小于等于安全值同步0，不调下架接口',
      edit: '编辑网店',
      NEW: '新建店铺',
      ps: '请输入网店名称',
      ps1: '请选择渠道类型',
      ps2: '请选择网店类型',
      ps3: '请输入负责人',
      ps4: '请选择所属公司',
      ps5: '请选择发票种类',
      ps6: '请输入网店地址',
      ps7: '请选择渠道仓',
      ps8: '请输入渠道仓的名称',
    },
    Footer: {
      title: '库存超卖限制',
      total: '每个比例虚仓能连接的所有渠道仓的比例总数不超过',
      The: '*每个实仓能连接的所有比例虚仓的比例总数等于100%',
    },
    csg: {
      name: '商店名称',
      shopify: {
        appKey: 'API秘钥',
        appSecret: 'API 密码',
        apiServiceUrl: '商店链接',
        appKey1: 'APP ID',
        appSecret1: 'APP 密码',
      },
      wooCommerce: {
        appKey: '客户端密钥 ID',
        appSecret: '客户端密钥',
        apiServiceUrl: '商店链接',
      },
      magento: {
        appKey: 'Magento 用户名',
        appSecret: 'API 密码',
        apiServiceUrl: '商店链接',
        bpCode: '仓库 ID'
      },
      cin7: {
        appKey: 'Cin7 用户名',
        appSecret: 'Cin7 密码',
        apiServiceUrl: '商店链接',
        bpCode: '仓库 ID',
      },
      cin7Core: {
        appKey: '账户ID',
        appSecret: '密钥',
      },
      maropost: {
        appKey: 'Magento 用户名',
        appKeyNew: '用户名',
        appSecret: 'API 密码',
        apiServiceUrl: '商店链接',
        bpCode: '仓库 ID',
      },
      channelAdvisor: {
        appKey: '客户端 ID',
        appSecret: '客户端秘钥',
        authAccount: '刷新令牌',
        accountCode: '档案 ID',
        project: '配送中心 ID',
        WhetherGoods: '商品运费险',
        PleaseNote: '请注意：开启保险功能，会额外增加物流运费'
      },
      edi: {
        Retailer: '零售商',
      }
    },
    cron: {
      orderConfig: '店铺订单配置',
      CardType: '卡单类型',
      cardOrder: '按小时卡单',
      cardSheet: '按日期卡单',
      ForeverStuck: '永远卡单',
      Hour: '小时',
      Day: '日',
      Week: '周',
      AnyHour: '任意小时',
      CycleFrom: '周期从',
      Specify: '指定',
      AnyWeek: '任意周',
      AnyDay: '任意日',
      CycleFromWeek: '周期从星期',
      MultipleChoices: '可多选',
      WhetherSkipWeekend: '是否跳过周末',
      Monday: '周一',
      Tuesday: '周二',
      Wednesday: '周三',
      Thursday: '周四',
      Friday: '周五',
      Saturday: '周六',
      Sunday: '周日'
    }
  },
};
